module.exports = __webpack_public_path__ + "img/umm.7eaa660e.png";